export enum InvoiceStatus {
    Created = "created",
    Pending = "pending_payment",
    Canceled = "canceled",
    Paid = "paid",
    Delayed = "delayed",
    Failed = "failed",
}
